import { madhatterGraphqlClient } from '@madxnl/mrrabbit'

export interface WeeklySignupInsight {
  weekStart: string
  signups: number
  savedWorkouts: number
  activeAccounts: number
}

export interface UserInsights {
  totalUsers: number
  newUsersLast30Days: number
  profileCompletionRate: number
  savedWorkoutsInPeriod: number
  activeAccountsInPeriod: number
  weekOffset: number
  hasOlderWeeks: boolean
  hasNewerWeeks: boolean
  reportingTimeZone: string
  weeklySignups: WeeklySignupInsight[]
}

export async function fetchUserInsights(weekOffset = 0): Promise<UserInsights> {
  const data = await madhatterGraphqlClient.query({
    operationName: 'userInsights',
    fields: {
      totalUsers: true,
      newUsersLast30Days: true,
      profileCompletionRate: true,
      savedWorkoutsInPeriod: true,
      activeAccountsInPeriod: true,
      weekOffset: true,
      hasOlderWeeks: true,
      hasNewerWeeks: true,
      reportingTimeZone: true,
      weeklySignups: {
        weekStart: true,
        signups: true,
        savedWorkouts: true,
        activeAccounts: true,
      },
    },
    variables: {
      userInsights: { weekOffset },
    },
  })
  return data.userInsights
}

export interface WeeklyWorkoutInsight {
  weekStart: string
  completedWorkouts: number
}

export interface RankedWorkoutInsight {
  key: string
  name: string
  count: number
}

export interface TimeSpentWorkoutInsight {
  key: string
  name: string
  totalMinutes: number
}

export interface WorkoutInsights {
  completedWorkoutsInPeriod: number
  weekOffset: number
  hasOlderWeeks: boolean
  hasNewerWeeks: boolean
  reportingTimeZone: string
  weeklyCompletedWorkouts: WeeklyWorkoutInsight[]
  topCompletedWorkouts: RankedWorkoutInsight[]
  mostTimeSpentWorkouts: TimeSpentWorkoutInsight[]
}

export async function fetchWorkoutInsights(weekOffset = 0): Promise<WorkoutInsights> {
  const data = await madhatterGraphqlClient.query({
    operationName: 'workoutInsights',
    fields: {
      completedWorkoutsInPeriod: true,
      weekOffset: true,
      hasOlderWeeks: true,
      hasNewerWeeks: true,
      reportingTimeZone: true,
      weeklyCompletedWorkouts: {
        weekStart: true,
        completedWorkouts: true,
      },
      topCompletedWorkouts: {
        key: true,
        name: true,
        count: true,
      },
      mostTimeSpentWorkouts: {
        key: true,
        name: true,
        totalMinutes: true,
      },
    },
    variables: {
      workoutInsights: { weekOffset },
    },
  })
  return data.workoutInsights
}

export async function fetchBagLogs(bagId: string) {
  const data = await madhatterGraphqlClient.query({
    operationName: 'logByBagId',
    fields: { log: true },
    variables: {
      logByBagId: { input: bagId },
    },
  })
  return data.logByBagId
}
